export default "__VITE_ASSET__4X5Fy9Nd__"